<div class="condition-block">
  <div class="row space-between">
    <div class="col-md-10">
        <div style="font-size: 12px; font-weight: bold; margin-bottom: 5px;">
          Condition Type
          <mat-button-toggle-group class="small-toggle" [formControl]="toggleControl">
            <mat-button-toggle value="{{PipelineFilterConditionType.AND}}">AND</mat-button-toggle>
            <mat-button-toggle value="{{PipelineFilterConditionType.OR}}">OR</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
    </div>
    <div class="col-md-2">
      <div class="clear-button" (click)="clearConditionalData()"><span>Clear Conditions<mat-icon style="font-size: 18px">playlist_remove</mat-icon></span></div>
    </div>
  </div>
  @for(condition of conditionGroups; track condition;){
    @if(pipeFilterService.getControl(condition, 'conditionType').value!==null){
      <div class="row">{{condition.controls['conditionType'].value.toUpperCase()}}</div>
    }
<!--    Select First Field-->
    <div class="row align-top">
      <div class="col-md-3">
        <mat-form-field class="dense-field" subscriptSizing="dynamic">
          <input matInput type="text" placeholder="Select field..."
                 [formControl]="pipeFilterService.getControl(condition, 'field')"
                 [matAutocomplete]="fieldauto"
          />
          <mat-autocomplete #fieldauto="matAutocomplete" (optionSelected)="onFieldSelected($event,condition)" [displayWith]="displayFn">
            @for(option of (filteredFields(condition) | async); track option.id){
              <mat-option [value]="option">{{option.name}}</mat-option>
            }
          </mat-autocomplete>
<!--          <mat-select [formControl]="pipeFilterService.getControl(condition, 'field')" (selectionChange)="onConditionChange(condition)">-->
<!--            @for(field of (pipelineService.fieldFilters$ | async); track field.id){-->
<!--              <mat-option [value]="field">{{field.name}}</mat-option>-->
<!--            }-->
<!--          </mat-select>-->
        </mat-form-field>
      </div>

<!--      Not JSON-->
<!--      Standard Conditional Dropdown-->
      @if(pipeFilterService.checkSelected(condition, 'field') && !pipeFilterService.isJsonFormatField(condition)
        && pipeFilterService.getControl(condition, 'field').value?.children?.length==0){
        @if(pipeFilterService.getControl(condition, 'field').value?.format == 'boolean'){
          <div class="col-md-3">
            <mat-form-field class="dense-field" subscriptSizing="dynamic">
              <mat-select [formControl]="pipeFilterService.getControl(condition, 'value')" (selectionChange)="onConditionChange(condition)" [compareWith]="compareOptions">
                @for(selection of pipeFilterService.getConditionSelectionByType(pipeFilterService.getControl(condition, 'field').value?.name === 'Pipeline Dates' ? 'date' : pipeFilterService.getControl(condition, 'field').value['format']);track selection['name']){
                  <mat-option [value]="selection">{{ selection['name'] }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if(pipeFilterService.getControl(condition, 'field').value.format !== 'boolean'){
          <div class="col-md-3">
            <mat-form-field class="dense-field" subscriptSizing="dynamic">
              <mat-select [formControl]="pipeFilterService.getControl(condition, 'condition')" (selectionChange)="onConditionChange(condition)">
                @for(selection of pipeFilterService.getConditionSelectionByType(pipeFilterService.getControl(condition, 'field').value?.name === 'Pipeline Dates' ? 'date' : pipeFilterService.getControl(condition, 'field').value['format']);track selection['name']){
                  <mat-option [value]="selection">{{ selection['name'] }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

        }
      }

<!--      Condition Special Lookup-->
      @if(pipeFilterService.checkSelected(condition, 'field') && pipeFilterService.isJsonFormatField(condition) && pipeFilterService.isSpecialLookup(condition)){
        <div class="col-md-3">
          <mat-form-field class="dense-field" subscriptSizing="dynamic">
            <mat-select [formControl]="pipeFilterService.getControl(condition, 'fieldValue')" [compareWith]="compareOptions">
              @for(option of pipelineService.getModelSelections(condition); track option.index){
                <mat-option [value]="option">{{option.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      @if(pipeFilterService.checkSelected(condition, 'fieldValue')){
        @if(pipeFilterService.getControl(condition, 'field').value.name=='Pipeline Dates'){
          <div class="col-md-2">
            <mat-form-field class="dense-field" subscriptSizing="dynamic">
              <mat-select [formControl]="pipeFilterService.getControl(condition, 'condition')" [compareWith]="compareOptions">
                @for(option of pipeFilterService.getConditionSelectionByType('date'); track $index){
                  <mat-option [value]="option">{{option["name"]}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        } @else {
          <div class="col-md-3">
            <mat-form-field class="dense-field" subscriptSizing="dynamic">
              <mat-select [formControl]="pipeFilterService.getControl(condition, 'condition')" [compareWith]="compareOptions">
                @for(option of pipeFilterService.getConditionSelectionFromChildrenByType(pipeFilterService.getControl(condition, 'field').value['children']); track $index){
                  <mat-option [value]="option">{{option["name"]}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

        }
      }
<!-- Value Standard-->
      @if(pipeFilterService.checkSelected(condition, 'condition')
      && !pipeFilterService.isJsonFormatField(condition)
      && !pipeFilterService.isSpecialLookup(condition)
        && !pipeFilterService.isMultiSelect(condition)
        && pipeFilterService.getControl(condition, 'condition').value.name !== 'Is Empty'
        && pipeFilterService.getControl(condition, 'condition').value.name !== 'Is Not Empty'){
        <div class="col-md-3">
<!--          String Field-->
          @if((pipeFilterService.getControl(condition, 'field').value.format=='string' || pipeFilterService.getControl(condition, 'field').value.format=='select')
            && !pipeFilterService.isTypeAhead(condition)){
            <mat-form-field class="dense-field" subscriptSizing="dynamic">
              <input matInput type="text" [formControl]="pipeFilterService.getControl(condition, 'value')">
            </mat-form-field>
          }
          @if((pipeFilterService.getControl(condition, 'field').value.format=='string' || pipeFilterService.getControl(condition, 'field').value.format=='select')
          && pipeFilterService.isTypeAhead(condition)){
            @if(pipeFilterService.getControl(condition, 'condition').value.name == 'Equals' || pipeFilterService.getControl(condition, 'condition').value.name == 'Does Not Equal'){
              <mat-form-field class="dense-field" subscriptSizing="dynamic">
                <input matInput type="text" [formControl]="pipeFilterService.getControl(condition, 'value')" (input)="onValueChange($event, condition, 'field')" [matAutocomplete]="valueAuto">
                <mat-autocomplete #valueAuto="matAutocomplete" [displayWith]="displayVal">
                  @for(option of getTypeAheadResults(condition) | async; track option){
                    <mat-option [value]="option">{{option.name ?? option}}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            }
            @if(pipeFilterService.getControl(condition, 'condition').value.name !== 'Equals' && pipeFilterService.getControl(condition, 'condition').value.name !== 'Does Not Equal'){
              <mat-form-field class="dense-field" subscriptSizing="dynamic">
                <input matInput type="text" [formControl]="pipeFilterService.getControl(condition, 'value')">
              </mat-form-field>
            }
          }
          @if(pipeFilterService.getControl(condition, 'field').value.format=='currency' || pipeFilterService.getControl(condition, 'field').value.format=='int'
            || pipeFilterService.getControl(condition, 'field').value.format=='percentage'){
            <mat-form-field class="dense-field" subscriptSizing="fixed">
              @if(pipeFilterService.getControl(condition, 'field').value.format==='currency'){
                <span matTextPrefix>$&nbsp;</span>
              }
              @if(pipeFilterService.getControl(condition, 'field').value.format==='percentage'){
                <span matTextPrefix>%&nbsp;</span>
              }
              <input matInput type="number" [formControl]="pipeFilterService.getControl(condition, 'value')">
              @if(pipeFilterService.getControl(condition, 'field').value.format==='percentage'){
                <mat-hint style="font-size: 10px">Percentage must be entered in decimals. Ex 0.65 = 65%</mat-hint>
              }
            </mat-form-field>
          }
          @if(pipeFilterService.getControl(condition, 'field').value.format=='date'){
            <mat-form-field class="dense-field" subscriptSizing="dynamic">
              <input matInput type="text" [formControl]="pipeFilterService.getControl(condition, 'value')" [matDatepicker]="datepicker">
              <mat-datepicker-toggle
                matIconSuffix
                [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker></mat-datepicker>
            </mat-form-field>
          }
        </div>
<!--        Second value "In Between"-->
        @if(pipeFilterService.isBetweenCondition(condition)){
          <div class="col-md-3">
            @if(pipeFilterService.getControl(condition, 'field').value.format=='currency' || pipeFilterService.getControl(condition, 'field').value.format=='int'
              || pipeFilterService.getControl(condition, 'field').value.format=='percentage'){
              <mat-form-field class="dense-field" subscriptSizing="fixed">
                @if(pipeFilterService.getControl(condition, 'field').value.format==='currency'){
                  <span matTextPrefix>$&nbsp;</span>
                }
                @if(pipeFilterService.getControl(condition, 'field').value.format==='percentage'){
                  <span matTextPrefix>%&nbsp;</span>
                }
                <input matInput type="number" placeholder="To" [formControl]="pipeFilterService.getControl(condition, 'valueTo')">
                @if(pipeFilterService.getControl(condition, 'field').value.format==='percentage'){
                  <mat-hint style="font-size: 10px">Percentage must be entered in decimals. Ex 0.65 = 65%</mat-hint>
                }
              </mat-form-field>
            }
            @if(pipeFilterService.getControl(condition, 'field').value.format=='date'){
              <mat-form-field class="dense-field" subscriptSizing="dynamic">
                <input matInput type="text" placeholder="To" [formControl]="pipeFilterService.getControl(condition, 'valueTo')" [matDatepicker]="datepicker">
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker></mat-datepicker>
              </mat-form-field>
            }
          </div>
        }
      }
      @if(pipeFilterService.checkSelected(condition, 'condition')
      && pipeFilterService.isJsonFormatField(condition)
      && pipeFilterService.isSpecialLookup(condition)
      && !pipeFilterService.isMultiSelect(condition)
      && pipeFilterService.getControl(condition, 'condition').value.name !== 'Is Empty'
      && pipeFilterService.getControl(condition, 'condition').value.name !== 'Is Not Empty'){

        @if(pipeFilterService.getControl(condition, 'field').value?.name === 'Pipeline Dates'){
          <div class="col-md-2">
            <mat-form-field class="dense-field" subscriptSizing="dynamic">
              <input matInput type="text" placeholder="To" [formControl]="pipeFilterService.getControl(condition, 'value')" [matDatepicker]="datepicker">
              <mat-datepicker-toggle
                matIconSuffix
                [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker></mat-datepicker>
            </mat-form-field>
          </div>
          @if(pipeFilterService.isBetweenCondition(condition)) {
            <div class="col-md-2">
            <mat-form-field class="dense-field" subscriptSizing="dynamic">
              <input matInput type="text" placeholder="From" [formControl]="pipeFilterService.getControl(condition, 'valueTo')" [matDatepicker]="datepicker">
              <mat-datepicker-toggle
                matIconSuffix
                [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker></mat-datepicker>
            </mat-form-field>
            </div>
          }

        }@else{
          <div class="col-md-3">
            <mat-form-field class="dense-field" subscriptSizing="dynamic">
              <mat-select [formControl]="pipeFilterService.getControl(condition, 'value')" multiple
                          [compareWith]="compareOptions"
                          [matTooltip]="pipeFilterService.getSelectedLabels(condition, 'value')"
                          [matTooltipDisabled]="!pipeFilterService.getSelectedLabels(condition, 'value')"
                          matTooltipClass="multiselect-tooltip"
              >
                @for(option of pipelineService.getSubSelections(condition); track $index){
                  <mat-option [value]="option">{{option.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      }
<!--      Multiselect-->
      @if(pipeFilterService.checkSelected(condition, 'condition')
        && !pipeFilterService.isJsonFormatField(condition)
        && !pipeFilterService.isSpecialLookup(condition)
        && pipeFilterService.isMultiSelect(condition)
        && pipeFilterService.getControl(condition, 'condition').value.name !== 'Is Empty'
        && pipeFilterService.getControl(condition, 'condition').value.name !== 'Is Not Empty'){
        <div class="col-md-3">
          <mat-form-field class="dense-field" subscriptSizing="dynamic">
            <mat-select [formControl]="pipeFilterService.getControl(condition, 'value')" [multiple]="!pipeFilterService.isBetweenCondition(condition)" [compareWith]="compareOptions">
              @for(option of pipelineService.getModelSelections(condition); track option.index){
                <mat-option [value]="option">{{option.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        @if(pipeFilterService.isBetweenCondition(condition)){
          <div class="col-md-3">
            <mat-form-field class="dense-field" subscriptSizing="dynamic">
              <mat-select [formControl]="pipeFilterService.getControl(condition, 'valueTo')" [compareWith]="compareOptions">
                @for(option of pipelineService.getModelSelections(condition); track option.index){
                  <mat-option [value]="option">{{option.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      }
      <div class="delete-condition-row" (click)="removeCondition(condition)"><mat-icon>delete</mat-icon></div>
    </div>
<!--      Has JSON-->
    @if(pipeFilterService.checkSelected(condition, 'field')
    && pipeFilterService.isJsonFormatField(condition)
      && !pipeFilterService.isSpecialLookup(condition)
      && !pipeFilterService.isMultiSelect(condition)){
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-10">
      @for(form of pipeFilterService.getChildFormArray(condition).controls; track form){
          <div class="row align-top">
            <div class="col-md-3">
              <mat-form-field class="dense-field" subscriptSizing="dynamic">
                <mat-select [formControl]="pipeFilterService.getControl(form, 'fieldValue')" [compareWith]="compareOptions">
                  @for(option of pipeFilterService.getChildrenSelection(condition); track option.id){
                    <mat-option [value]="option">{{option.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            @if(pipeFilterService.checkSelected(form, 'fieldValue')){
              @if(pipeFilterService.getControl(form, 'fieldValue').value.format!=='boolean'){
                <div class="col-md-3">
                  <mat-form-field class="dense-field" subscriptSizing="dynamic">
                    <mat-select [formControl]="pipeFilterService.getControl(form, 'condition')" (selectionChange)="onConditionChange(form, 'fieldValue')" [compareWith]="compareOptions">
                      @for(option of pipeFilterService.getConditionSelectionByType(pipeFilterService.getControl(condition, 'field').value?.name === 'Pipeline Dates' ? 'date' : pipeFilterService.getControl(form, 'fieldValue').value['format']); track option['name']){
                        <mat-option [value]="option">{{option['name']}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
              @if(pipeFilterService.getControl(form, 'fieldValue').value.format=='boolean'){
                <div class="col-md-3">
                  <mat-form-field class="dense-field" subscriptSizing="dynamic">
                    <mat-select [formControl]="pipeFilterService.getControl(form, 'value')" (selectionChange)="onConditionChange(form, 'fieldValue')">
                      @for(option of pipeFilterService.getConditionSelectionByType(pipeFilterService.getControl(condition, 'field').value?.name === 'Pipeline Dates' ? 'date' : pipeFilterService.getControl(form, 'fieldValue').value['format']); track option['name']){
                        <mat-option [value]="option">{{option['name']}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }

            }
            @if(pipeFilterService.checkSelected(form, 'condition')
              && pipeFilterService.getControl(form, 'condition').value.name!=='Is Empty'
              && pipeFilterService.getControl(form, 'condition').value.name!=='Is Not Empty'){
              <div class="col-md-3 last-value">
                @if((pipeFilterService.getControl(form, 'fieldValue').value.format=='string' || pipeFilterService.getControl(form, 'fieldValue').value.format=='select')
                  && pipeFilterService.isTypeAhead(form, 'fieldValue')){
                  @if(pipeFilterService.getControl(form, 'condition').value.name=='Equals' || pipeFilterService.getControl(form, 'condition').value.name=='Does Not Equal'){
                    <mat-form-field class="dense-field" subscriptSizing="dynamic">
                        <input matInput type="text" [formControl]="pipeFilterService.getControl(form, 'value')" (input)="onValueChange($event, form, 'fieldValue')"
                        [matAutocomplete]="jsonauto">
                      <mat-autocomplete #jsonauto="matAutocomplete" [displayWith]="displayVal">
                        @for(option of getTypeAheadResults(form) | async; track option){
                          <mat-option [value]="option">{{option.name ?? option}}</mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                  }
                  @if(pipeFilterService.getControl(form, 'condition').value.name!=='Equals' && pipeFilterService.getControl(form, 'condition').value.name!=='Does Not Equal'){
                    <mat-form-field class="dense-field" subscriptSizing="dynamic">
                      <input matInput type="text" [formControl]="pipeFilterService.getControl(form, 'value')" />
                    </mat-form-field>
                  }
                }
                @if(pipeFilterService.getControl(form, 'fieldValue').value.format=='string'
                && !pipeFilterService.isTypeAhead(form, 'fieldValue')){
                  <mat-form-field class="dense-field" subscriptSizing="dynamic">
                    <input matInput type="text" [formControl]="pipeFilterService.getControl(form, 'value')">
                  </mat-form-field>
                }
                @if(pipeFilterService.getControl(form, 'fieldValue').value.format=='select'
                && !pipeFilterService.isTypeAhead(form, 'fieldValue') && !pipeFilterService.isMultiSelect(form, 'fieldValue')){
                  <mat-form-field class="dense-field" subscriptSizing="dynamic">
                    <mat-select [formControl]="pipeFilterService.getControl(form, 'value')"
                                multiple
                                [compareWith]="compareOptions"
                                [matTooltip]="pipeFilterService.getSelectedLabels(form, 'value')"
                                [matTooltipDisabled]="!pipeFilterService.getSelectedLabels(form, 'value')"
                                matTooltipClass="multiselect-tooltip"
                    >
                      @for(option of pipelineService.getSubSelections(form); track option){
                        <mat-option [value]="option">{{option.name}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if(pipeFilterService.getControl(form, 'fieldValue').value.format=='select'
                && !pipeFilterService.isTypeAhead(form, 'fieldValue') && pipeFilterService.isMultiSelect(form, 'fieldValue')){
                  <mat-form-field class="dense-field" subscriptSizing="dynamic">
                    <mat-select [formControl]="pipeFilterService.getControl(form, 'value')" multiple
                    [matTooltip]="pipeFilterService.getSelectedLabels(form, 'value')"
                    [matTooltipDisabled]="!pipeFilterService.getSelectedLabels(form, 'value')"
                                [compareWith]="compareOptions"
                    matTooltipClass="multiselect-tooltip"
                    >
                      @for(option of pipelineService.getModelSelections(form, 'fieldValue'); track option){
                        <mat-option [value]="option">{{option.name}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if(pipeFilterService.getControl(form, 'fieldValue').value.format=='currency' || pipeFilterService.getControl(form, 'fieldValue').value.format=='int' || pipeFilterService.getControl(form, 'fieldValue').value.format=='percentage'){
                  <mat-form-field class="dense-field" subscriptSizing="fixed">
                    @if(pipeFilterService.getControl(form, 'fieldValue').value.format==='currency'){
                      <span matTextPrefix>$&nbsp;</span>
                    }
                    @if(pipeFilterService.getControl(form, 'fieldValue').value.format==='percentage'){
                      <span matTextPrefix>%&nbsp;</span>
                    }
                    <input matInput type="number" [formControl]="pipeFilterService.getControl(form, 'value')">
                  </mat-form-field>
                  @if(pipeFilterService.getControl(form, 'fieldValue').value.format=='percentage'){
                    <mat-hint>Percentage must be entered in decimals. Ex 0.65 = 65%</mat-hint>
                  }
                }
                @if(pipeFilterService.getControl(form, 'fieldValue').value.format=='date' || pipeFilterService.getControl(form, 'field').value?.name==='Pipeline Dates'){
                  <mat-form-field class="dense-field" subscriptSizing="dynamic">
                    <input matInput type="text" [formControl]="pipeFilterService.getControl(form, 'value')" [matDatepicker]="datepicker">
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="datepicker"></mat-datepicker-toggle>
                    <mat-datepicker #datepicker></mat-datepicker>
                  </mat-form-field>
                }
<!--                <div class="delete-sub-condition-row" (click)="removeSubCondition(condition, form)"><mat-icon>delete</mat-icon></div>-->
              </div>
              @if(pipeFilterService.isBetweenCondition(form)){
                <div class="col-md-3">
                  @if(pipeFilterService.getControl(form, 'fieldValue').value.format=='currency' || pipeFilterService.getControl(form, 'fieldValue').value.format=='int'
                  || pipeFilterService.getControl(form, 'fieldValue').value.format=='percentage'){
                    @if(pipeFilterService.getControl(condition, 'fieldValue').value.format==='currency'){
                      <span matTextPrefix>$&nbsp;</span>
                    }
                    @if(pipeFilterService.getControl(condition, 'fieldValue').value.format==='percentage'){
                      <span matTextPrefix>%&nbsp;</span>
                    }
                    <mat-form-field class="dense-field" subscriptSizing="dynamic">
                      <input matInput type="number" placeholder="To" [formControl]="pipeFilterService.getControl(form, 'valueTo')">
                    </mat-form-field>
                    @if(pipeFilterService.getControl(form, 'fieldValue').value.format=='percentage'){
                      <mat-hint>Percentage must be entered in decimals. Ex 0.65 = 65%</mat-hint>
                    }
                  }
                  @if(pipeFilterService.getControl(form, 'fieldValue').value.format=='date'){
                    <mat-form-field class="dense-field" subscriptSizing="dynamic">
                      <input matInput type="text" placeholder="To" [formControl]="pipeFilterService.getControl(form, 'valueTo')" [matDatepicker]="datepicker">
                      <mat-datepicker-toggle
                        matIconSuffix
                        [for]="datepicker"></mat-datepicker-toggle>
                      <mat-datepicker #datepicker></mat-datepicker>
                    </mat-form-field>
                  }
                </div>
              }
              <div class="col-md-3">
                <div class="delete-sub-condition-row" (click)="removeSubCondition(condition, form)"><mat-icon>delete</mat-icon></div>
              </div>
            }
          </div>
      }
          <div class="row">
            <div class="flat-transparent-button" (click)="addInternalSubCondition(condition)">+ Add {{pipeFilterService.getControl(condition, 'field')?.value?.name}} Condition</div>
          </div>
        </div>
      </div>
    }
  }
  <div class="row space-between">
    <div class="flat-transparent-button" (click)="addInternalCondition()">+ Add Condition</div>
    @if(index!==0){
      <div class="flat-transparent-button" (click)="removeConditionBlock()">Delete Condition Block</div>
    }
  </div>
</div>
